var _defs, _g, _text, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "foldGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e53935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b71c1c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#000",
    floodOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0h40l12 12v52H12z",
    fill: "url(#bgGrad)",
    stroke: "#ccc",
    strokeWidth: 2,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 0v12h12z",
    fill: "url(#foldGrad)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 42,
    textAnchor: "middle",
    fill: "#e53935",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "PDF")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 48,
    x2: 44,
    y2: 48,
    stroke: "#e53935",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 52l4 4 8-8",
    fill: "none",
    stroke: "#888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.fd8e3268c65853fa7c506d84dfa7966c.svg";
export { ForwardRef as ReactComponent };